import { ChevronDown } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router";

import { useLogout } from "@/api/hooks";
import { Avatar } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { useAuth } from "@/state/auth";

export function UserMenu() {
  const me = useAuth();
  const navigate = useNavigate();
  const logout = useLogout();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  async function onLogout() {
    setOpen(false);
    try {
      await logout.mutateAsync();
    } finally {
      navigate("/login", { replace: true });
    }
  }

  return (
    <div className="relative" ref={ref}>
      <button
        aria-expanded={open}
        aria-haspopup="menu"
        className="flex items-center gap-3 rounded-lg p-1 text-left transition hover:bg-[#f5f6fa] dark:hover:bg-[#202629]"
        onClick={() => setOpen((v) => !v)}
        type="button"
      >
        <Avatar className="h-12 w-12" fallback={me.email.charAt(0).toUpperCase()} />
        <div className="hidden sm:block">
          <p className="text-sm font-bold">Mario</p>
          <p className="max-w-[180px] truncate text-xs text-[#8190b0]">{me.email}</p>
        </div>
        <ChevronDown className="h-5 w-5" />
      </button>
      {open ? (
        <div
          className="absolute right-0 top-14 z-50 w-56 rounded-xl border border-[#dfe3eb] bg-white p-2 shadow-lg dark:border-[#3f4548] dark:bg-[#202629]"
          role="menu"
        >
          <Link
            className="block rounded-lg px-3 py-2 text-sm font-medium hover:bg-[#edf2ff] hover:text-[#4077f6] dark:hover:bg-[#2a3135]"
            onClick={() => setOpen(false)}
            role="menuitem"
            to="/ajustes"
          >
            Ajustes
          </Link>
          <button
            className={cn(
              "block w-full rounded-lg px-3 py-2 text-left text-sm font-medium text-[#ff3434] hover:bg-[#edf2ff] dark:hover:bg-[#2a3135]",
            )}
            onClick={onLogout}
            role="menuitem"
            type="button"
          >
            Cerrar sesión
          </button>
        </div>
      ) : null}
    </div>
  );
}
